const cards = [
  {
    title: '2024年度十佳国产剧盘点',
    desc: '从古装权谋到都市情感，这一年国产剧给了我们太多惊喜与感动。我们精选了十部值得反复回味的口碑佳作。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=collection%20of%20Chinese%20drama%20DVD%20cases%20displayed%20on%20wooden%20shelf%20with%20warm%20spotlight%2C%20elegant%20arrangement%2C%20cinema%20memorabilia%20aesthetic%2C%20soft%20ambient%20lighting%2C%20cozy%20home%20theater%20corner&width=800&height=500&seq=card-01-2026&orientation=landscape',
  },
  {
    title: '暑期档必看：10部清凉爽片',
    desc: '炎热夏日窝在家吹空调看电影就是最幸福的事，这份片单从动作到喜剧一应俱全。',
    tag: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=summer%20movie%20night%20setup%20with%20projector%20screen%20in%20backyard%2C%20string%20lights%2C%20popcorn%20and%20cold%20drinks%2C%20cozy%20outdoor%20seating%2C%20twilight%20sky%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20vibe&width=800&height=500&seq=card-02-2026&orientation=landscape',
  },
  {
    title: '韩剧入坑指南：从入门到精通',
    desc: '不知道从哪部开始看韩剧？这份分阶段推荐指南，帮你找到最适合的追剧起点。',
    tag: '追剧攻略',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20posters%20collage%20on%20minimalist%20wall%2C%20modern%20interior%20with%20warm%20lighting%2C%20elegant%20living%20room%20setting%2C%20soft%20pastel%20color%20scheme%2C%20clean%20aesthetic%2C%20multiple%20frames%20in%20harmonious%20arrangement&width=800&height=500&seq=card-03-2026&orientation=landscape',
  },
  {
    title: '科幻迷狂喜：硬核科幻影视宇宙',
    desc: '从《暗夜边境》到国产科幻新作，构建你的科幻世界观，探索未来的一万种可能。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20spaceship%20bridge%20with%20holographic%20displays%2C%20stars%20visible%20through%20large%20windows%2C%20sleek%20sci-fi%20interior%20design%2C%20cool%20blue%20ambient%20lighting%2C%20advanced%20technology%2C%20cinematic%20wide%20angle%20view&width=800&height=500&seq=card-04-2026&orientation=landscape',
  },
  {
    title: '午夜档恐怖片精选：挑战你的胆量',
    desc: '精选十部氛围营造顶级的恐怖佳作，从心理惊悚到超自然恐怖，深夜独享的极致刺激。',
    tag: '类型精选',
    image: 'https://readdy.ai/api/search-image?query=dark%20haunted%20Victorian%20mansion%20corridor%20with%20flickering%20candlelight%2C%20long%20shadows%20on%20walls%2C%20mysterious%20atmosphere%2C%20gothic%20interior%2C%20dust%20particles%20in%20moonlight%2C%20eerie%20yet%20beautiful%20composition&width=800&height=500&seq=card-05-2026&orientation=landscape',
  },
  {
    title: '周末亲子时光：全家共享动画清单',
    desc: '适合全家一起观看的高分动画电影，有趣又暖心，让孩子在欢笑中收获成长。',
    tag: '亲子推荐',
    image: 'https://readdy.ai/api/search-image?query=cozy%20family%20living%20room%20with%20parents%20and%20children%20watching%20colorful%20animated%20movie%20on%20large%20TV%20screen%2C%20warm%20ambient%20lighting%2C%20popcorn%20bowls%2C%20happy%20atmosphere%2C%20soft%20blankets%20on%20sofa&width=800&height=500&seq=card-06-2026&orientation=landscape',
  },
  {
    title: '冷门佳作发掘：那些被忽视的宝藏',
    desc: '这些影片可能没有豪华阵容和铺天宣传，但故事和表演绝对让你眼前一亮，部部都值得被发现。',
    tag: '编辑力荐',
    image: 'https://readdy.ai/api/search-image?query=vintage%20independent%20cinema%20with%20warm%20projector%20light%20beam%20through%20dusty%20air%2C%20old%20film%20reels%20and%20posters%2C%20nostalgic%20atmosphere%2C%20small%20art%20house%20theater%20interior%2C%20wooden%20seats%2C%20soft%20golden%20hour%20lighting&width=800&height=500&seq=card-07-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          编辑团队精心策划的影视专题，发现更多好看的
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((card) => (
            <article
              key={card.title}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-[180px] md:h-[200px]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-background-50 text-[10px] font-semibold rounded-full">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-5">
          <article className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative overflow-hidden w-full sm:w-[320px] h-[200px] sm:h-auto flex-shrink-0">
              <img
                src={cards[6].image}
                alt={cards[6].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500/90 text-background-50 text-[10px] font-semibold rounded-full">
                {cards[6].tag}
              </span>
            </div>
            <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {cards[6].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{cards[6].desc}</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}